/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Button,
  Flex,
  Image,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
export default function AddItemPage(props) {
  const { uploadImagesSection, documentButtonSubSection, overrides, ...rest } =
    props;
  return (
    <Flex
      gap="10px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "AddItemPage")}
      {...rest}
    >
      <Flex
        gap="10px"
        direction="column"
        width="400px"
        height="unset"
        justifyContent="flex-start"
        alignItems="center"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "AutoLayout")}
      >
        <Flex
          gap="0"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="10px 10px 0px 10px"
          {...getOverrideProps(overrides, "NavSection")}
        >
          <Button
            width="unset"
            height="unset"
            shrink="0"
            size="large"
            isDisabled={false}
            variation="link"
            children="<"
            {...getOverrideProps(overrides, "TitleBackButton")}
          ></Button>
          <Text
            fontFamily="Inter"
            fontSize="24px"
            fontWeight="600"
            color="rgba(59,135,165,1)"
            lineHeight="30px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            grow="1"
            shrink="1"
            basis="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Ajouter un nouvel objet"
            {...getOverrideProps(overrides, "TitleLabel")}
          ></Text>
        </Flex>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
          padding="10px 10px 10px 10px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "HeadSection")}
        >
          <TextField
            width="unset"
            height="unset"
            label="Nom de l’objet"
            placeholder="Entrer le nom de votre objet"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemNameTitleTextField")}
          ></TextField>
          <TextField
            width="unset"
            height="unset"
            label="Référence de l’objet"
            placeholder="Entrer la référence de votre objet"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemReferenceTextField")}
          ></TextField>
          <TextField
            width="unset"
            height="unset"
            label="Marque de l’objet"
            placeholder="Entrer la marque de votre objet"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemBrandTextField")}
          ></TextField>
          <TextField
            width="unset"
            height="unset"
            label="Enseigne, Lieu d’achat ..."
            placeholder="Nom du distributeur / site ecommerce ..."
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemCompanyTextField")}
          ></TextField>
          <TextField
            width="unset"
            height="unset"
            label="Date d’achat"
            placeholder="JJ/MM/AAAA"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "PurchaseDateTextField")}
          ></TextField>
          <TextField
            width="unset"
            height="unset"
            label="Prix d'achat en €"
            placeholder="Entrer le prix d'achat"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemPriceTextField")}
          ></TextField>
        </Flex>
        <Flex
          gap="25px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
          padding="10px 10px 10px 10px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "UploadSection")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "UploadDocumentSection")}
          >
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(48,64,80,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Uploader le ticket ou la facture"
              {...getOverrideProps(
                overrides,
                "UploadDocumentSectionDescriptionLabel"
              )}
            ></Text>
            <Flex
              gap="0"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 15px 0px 15px"
              {...getOverrideProps(overrides, "DocumentButtonSubSection")}
            >
              <Button
                width="unset"
                height="unset"
                grow="1"
                shrink="1"
                basis="0"
                size="default"
                isDisabled={false}
                variation="default"
                children="Ticket / Facture"
                {...getOverrideProps(overrides, "ReceiptButton")}
              ></Button>
            </Flex>
          </Flex>
          <Flex
            gap="10px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "UploadImagesSection")}
          >
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="400"
              color="rgba(48,64,80,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="380px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Uploader des photos de l’objet"
              {...getOverrideProps(overrides, "UploadImagesDescriptionLabel")}
            ></Text>
            <Flex
              gap="10px"
              direction="row"
              width="380px"
              height="unset"
              justifyContent="space-between"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="10px 10px 10px 10px"
              {...getOverrideProps(overrides, "UploadImagesSubSection")}
            >
              <Image
                width="100px"
                height="100px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                padding="0px 0px 0px 0px"
                objectFit="contain"
                {...getOverrideProps(overrides, "ItemImage0")}
              ></Image>
              <Image
                width="100px"
                height="100px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                padding="0px 0px 0px 0px"
                objectFit="contain"
                {...getOverrideProps(overrides, "ItemImage1")}
              ></Image>
              <Image
                width="100px"
                height="100px"
                display="block"
                gap="unset"
                alignItems="unset"
                justifyContent="unset"
                shrink="0"
                position="relative"
                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
                padding="0px 0px 0px 0px"
                objectFit="contain"
                {...getOverrideProps(overrides, "ItemImage2")}
              ></Image>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
          padding="10px 10px 10px 10px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "DescriptionSection")}
        >
          <TextAreaField
            width="unset"
            height="unset"
            label="Description de l’objet"
            descriptiveText="Vous pouvez modifier de texte de l'annonce générée par oobjo"
            placeholder="Entrer une description de l'objet ici"
            justifyContent="flex-start"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "ItemDescriptionTextAreaField")}
          ></TextAreaField>
        </Flex>
        <Flex
          gap="10px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="10px 10px 10px 10px"
          {...getOverrideProps(overrides, "ButtonsSection")}
        >
          <Button
            width="unset"
            height="unset"
            shrink="0"
            alignSelf="stretch"
            size="default"
            isDisabled={false}
            variation="primary"
            children="Ajouter à ma liste d’objets"
            {...getOverrideProps(overrides, "SaveItemButton")}
          ></Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
